<template>
  <div :class="['c-input-group', { 'c-input-group--is-inline': isInline }]">
    <div class="c-input-group__prepend" v-if="hasSlots('prepend')">
      <slot name="prepend"/>
    </div>
    <slot/>
    <div class="c-input-group__append" v-if="hasSlots('append')">
      <slot name="append"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseInputGroup',

    props: {
      isInline: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      hasSlots (name) {
        return this.$scopedSlots[name] && (this.$scopedSlots[name]() || []).some(item => !item.isComment)
      }
    }
  }
</script>
